/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Pick_TimeInputs */

const en_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a time`)
};

const es_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una hora`)
};

const de_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Zeit`)
};

const zh_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择时间`)
};

const ar_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر وقتاً`)
};

const fr_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une heure`)
};

const vi_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn giờ`)
};

const sw_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chagua wakati`)
};

const th_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกเวลา`)
};

const bs_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaberite vrijeme`)
};

const ja_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間を選ぶ`)
};

const ko_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시간 선택`)
};

const pt_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma hora`)
};

const it_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un orario`)
};

const sv_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj en tid`)
};

const nl_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een tijd`)
};

const da_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg tid`)
};

const nb_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg en tid`)
};

const fi_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse aika`)
};

const pl_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz godzinę`)
};

const ru_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите время`)
};

const tr_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir saat seçin`)
};

const hi_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक समय चुनें`)
};

const id_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih waktu`)
};

const ms_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih masa`)
};

const cs_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte čas`)
};

const el_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιλέξτε ώρα`)
};

const he_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחרו זמן`)
};

const af_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies 'n tyd`)
};

const hu_booking_pick_time = /** @type {(inputs: Booking_Pick_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válassz időpontot`)
};

/**
* | output |
* | --- |
* | "Pick a time" |
*
* @param {Booking_Pick_TimeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_pick_time = /** @type {((inputs?: Booking_Pick_TimeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Pick_TimeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_pick_time(inputs)
	if (locale === "de") return de_booking_pick_time(inputs)
	if (locale === "zh") return zh_booking_pick_time(inputs)
	if (locale === "ar") return ar_booking_pick_time(inputs)
	if (locale === "fr") return fr_booking_pick_time(inputs)
	if (locale === "vi") return vi_booking_pick_time(inputs)
	if (locale === "sw") return sw_booking_pick_time(inputs)
	if (locale === "th") return th_booking_pick_time(inputs)
	if (locale === "bs") return bs_booking_pick_time(inputs)
	if (locale === "ja") return ja_booking_pick_time(inputs)
	if (locale === "ko") return ko_booking_pick_time(inputs)
	if (locale === "pt") return pt_booking_pick_time(inputs)
	if (locale === "it") return it_booking_pick_time(inputs)
	if (locale === "sv") return sv_booking_pick_time(inputs)
	if (locale === "nl") return nl_booking_pick_time(inputs)
	if (locale === "da") return da_booking_pick_time(inputs)
	if (locale === "nb") return nb_booking_pick_time(inputs)
	if (locale === "fi") return fi_booking_pick_time(inputs)
	if (locale === "pl") return pl_booking_pick_time(inputs)
	if (locale === "ru") return ru_booking_pick_time(inputs)
	if (locale === "tr") return tr_booking_pick_time(inputs)
	if (locale === "hi") return hi_booking_pick_time(inputs)
	if (locale === "id") return id_booking_pick_time(inputs)
	if (locale === "ms") return ms_booking_pick_time(inputs)
	if (locale === "cs") return cs_booking_pick_time(inputs)
	if (locale === "el") return el_booking_pick_time(inputs)
	if (locale === "he") return he_booking_pick_time(inputs)
	if (locale === "af") return af_booking_pick_time(inputs)
	if (locale === "hu") return hu_booking_pick_time(inputs)
	return en_booking_pick_time(inputs)
});